module.exports = __webpack_public_path__ + "static/Rakshasa-d74cd65338be08625ad43db4eadb6ff7.jpg";